import React from "react";
import { Edit } from "react-admin";
import { CompanyTabbedForm } from "./CompanyTabbedForm";

export const CompanyEdit = (props) => (
  <Edit title="Editar Empresa" {...props}>
    <CompanyTabbedForm {...props} />
  </Edit>
);
